<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="6">
        <div class="pa-3">
          <v-row class="mt-3">
            <v-col cols="12" sm="3">
              <v-menu
                v-model="menu_date_start"
                transition="scale-transition"
                offset-y
                style="min-width: 288px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date_start"
                    label="วันที่เริ่มต้น"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date_start"
                  @input="menu_date_start = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="menu_date_end"
                transition="scale-transition"
                offset-y
                style="min-width: 288px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date_end"
                    label="วันที่สิ้นสุด"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    hide-details="auto"
                    v-on="on"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date_end"
                  @input="menu_date_end = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="2" class="w-100">
              <v-btn
                @click="exportExcel"
                color="green"
                class="white--text pa-3"
                width="100"
                height="55"
                >Export</v-btn
              >
            </v-col>
          </v-row>
          <v-card-title>
            <v-text-field
              v-model="search"
              color="#86bc3a"
              append-icon="mdi-magnify"
              label="ค้นหา"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="partnerHeader"
            :items="all_invoice"
            :footer-props="footer_Props"
            :search="search"
            mobile-breakpoint="0"
          >
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.item.invoice_code }}</td>
                <td>{{ dataDetail.item.updated_at }}</td>
                <td>{{ dataDetail.item.total }}</td>
                <td>
                  <div class="font-16">
                    {{ parsePayType(dataDetail.item.pay_type) }}
                  </div>
                </td>
                <td>
                  <v-btn
                    small
                    height="42"
                    @click="getInvoiceDetail(dataDetail.item.invoice_code)"
                    class="grad-success-bg white--text mr-1 mb-1"
                    title="ดูรายละเอียด"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
    <!-- รายละเอียด -->
    <v-dialog
      v-if="show_detail_bill"
      v-model="show_detail_bill"
      persistent
      max-width="650px"
    >
      <v-card class="input-radius">
        <v-card-title class="d-flex pt-2">
          <v-row>
            <v-col cols="12 text-right pt-5 pb-1 ">
              <v-btn icon class="ma-1" @click="close_model_all()">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </v-col>

            <v-col cols="12 pt-1">
              <v-col
                v-if="user_cancel != null"
                class="border-bill-red input-radius"
              >
                <div class="required--text">
                  สาเหตุการยกเลิกบิล : {{ detailList.invoice.cancel_note }}
                </div>
              </v-col>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container class="pa-7 border-bill input-radius">
            <v-row>
              <v-col cols="6">
                <div class="font-16">
                  {{ detailList.invoice.invoice_code }}
                </div>
              </v-col>
              <v-col cols="6 text-right">
                <div class="font-16">
                  {{
                    detailList.invoice.created_at != null
                      ? `${
                          detailList.invoice.created_at
                            .split("-")[2]
                            .split(" ")[0]
                        }/${detailList.invoice.created_at.split("-")[1]}/${
                          detailList.invoice.created_at.split("-")[0]
                        } @ ${
                          detailList.invoice.created_at
                            .split("-")[2]
                            .split(" ")[1]
                        }`
                      : "-"
                  }}
                </div>
              </v-col>
              <v-col cols="12 pt-0 pb-1">
                <div class="border-style-b pb-2 px-4"></div>
              </v-col>
            </v-row>
            <div id="bot" class="mt-5">
              <div id="table">
                <table>
                  <tr class="tabletitle">
                    <td class="font-13 item" style="width: 10px !important">
                      <h2>Item</h2>
                    </td>
                    <td class="font-13 text-center"><h2>ราคา</h2></td>
                    <td class="font-13 text-center"><h2>จำนวน</h2></td>
                    <td class="font-13 text-right"><h2>รวม</h2></td>
                  </tr>

                  <tr
                    v-for="(item, index) in detailList.invoice_list"
                    :key="index"
                    class="service"
                  >
                    <td class="tableitem font-13">
                      <p class="itemtext pr-2 mt-5">
                        {{ item.product_name }}
                      </p>
                      <p
                        class="pr-2 mt-5 font-10 text-center"
                        v-if="item.discount > 0"
                      >
                        ส่วนลด {{ item.product_name }}
                      </p>
                    </td>
                    <td class="tableitem font-13 text-center va-top">
                      <p class="itemtext mt-5">
                        {{ formatPrice(item.price) }}
                      </p>
                      <br v-if="item.discount > 0" />
                    </td>
                    <td class="tableitem font-13 text-center va-top">
                      <p class="itemtext mt-5" v-if="item.product_code == null">
                        -{{ item.qty }} {{ item.unit_name }}
                      </p>
                      <p class="itemtext mt-5" v-else>
                        {{ item.qty }} {{ item.unit_name }}
                      </p>
                      <br v-if="item.discount > 0" />
                    </td>
                    <td class="tableitem font-13 text-right va-top">
                      <p class="itemtext mt-5" v-if="item.product_code == null">
                        -{{
                          formatPrice(
                            parseFloat(item.total) + parseFloat(item.discount)
                          )
                        }}
                      </p>
                      <p class="itemtext mt-5" v-else>
                        {{
                          formatPrice(
                            parseFloat(item.total) + parseFloat(item.discount)
                          )
                        }}
                      </p>
                      <p class="itemtext mt-5" v-if="item.discount > 0">
                        -{{ formatPrice(item.discount) }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4">
                      <div class="border-style-b pb-2 px-4"></div>
                    </td>
                  </tr>

                  <tr class="tabletitle">
                    <td><p class="mt-5 font-13">รวมเงิน</p></td>
                    <td class="mt-5 font-13"></td>
                    <td>
                      <p class="mt-5 font-13 text-center">
                        {{ total_qty }} ชิ้น
                      </p>
                    </td>
                    <td class="text-right">
                      <p class="mt-5 font-12">
                        {{ formatPrice(total_price) }}
                      </p>
                    </td>
                  </tr>
                  <tr class="tabletitle">
                    <td><p class="mt-5 font-13">ส่วนลดท้ายบิล</p></td>
                    <td></td>
                    <td><p class="mt-5 font-13"></p></td>
                    <td class="text-right">
                      <p class="mt-5 font-12">
                        {{ formatPrice(detailList.invoice.discount) }}
                      </p>
                    </td>
                  </tr>
                  <tr class="tabletitle">
                    <td><p class="mt-5 font-13">มูลค่าสินค้า</p></td>
                    <td class="mt-5 font-13"></td>
                    <td>
                      <p class="mt-5 font-13 text-center">
                        {{ total_qty }} ชิ้น
                      </p>
                    </td>
                    <td class="text-right">
                      <p class="mt-5 font-12">
                        {{ formatPrice(detailList.invoice.cost) }}
                      </p>
                    </td>
                  </tr>
                  <tr class="tabletitle">
                    <td><p class="mt-5 font-13">ภาษีมูลค่าเพิ่ม 7%</p></td>
                    <td></td>
                    <td></td>
                    <td class="text-right">
                      <p class="mt-5 font-12">
                        {{ formatPrice(detailList.invoice.vat) }}
                      </p>
                    </td>
                  </tr>
                  <tr
                    class="tabletitle"
                    v-if="
                      detailList.invoice.credit_charge_status == 1 &&
                      detailList.invoice.pay_type.find((o) => o === 3)
                    "
                  >
                    <td>
                      <p class="mt-5 font-13">
                        เครดิตชาร์ต
                        {{ parseFloat(detailList.invoice.credit_charge) }}%
                      </p>
                    </td>
                    <td></td>
                    <td></td>
                    <td class="text-right">
                      <p class="mt-5 font-12">
                        {{
                          formatPrice(
                            parseFloat(detailList.invoice.credit_uncharge) *
                              parseFloat(detailList.invoice.credit_charge / 100)
                          )
                        }}
                      </p>
                    </td>
                  </tr>
                  <tr class="tabletitle">
                    <td><p class="mt-5 font-13">ยอดเงินสุทธิ</p></td>
                    <td></td>
                    <td></td>
                    <!-- <td v-if="detailList.invoice.credit_charge_status == 1 && detailList.invoice.pay_type.find(o => o === 3)" class="text-right"><p class="mt-5 font-13">{{ formatPrice(parseFloat(detailList.invoice.total) + (parseFloat(detailList.invoice.total) * parseFloat(detailList.invoice.credit_charge / 100))) }}</p></td> -->
                    <td class="text-right">
                      <p class="mt-5 font-12">
                        {{
                          formatPrice(
                            parseFloat(parseFloat(detailList.invoice.total))
                          )
                        }}
                      </p>
                    </td>
                  </tr>
                  <tr class="tabletitle">
                    <td><p class="mt-5 font-13">รับเงิน</p></td>
                    <td></td>
                    <td></td>
                    <td class="text-right">
                      <p class="mt-5 font-12">
                        {{ formatPrice(parseFloat(detailList.invoice.pay)) }}
                      </p>
                    </td>
                  </tr>
                  <tr class="tabletitle">
                    <td><p class="mt-5 font-13">เงินทอน</p></td>
                    <td></td>
                    <td></td>
                    <td class="text-right">
                      <p class="mt-5 font-12">
                        {{ formatPrice(parseFloat(detailList.invoice.change)) }}
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="4" v-if="seller.status_main_store != 1">
                      <div class="color-gray-mid font-10 mt-10">
                        * สาขา{{ seller.store_name }} {{ seller.tel }} *
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="4">
                      <div class="border-style-b pb-2 px-4"></div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="4">
                      <div class="font-12">
                        ข้อมูลสมาชิก {{ detailList.invoice.member_name }}
                      </div>
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td class="item"></td>
                    <td>
                      <p class="font-12 text-center">ได้รับ</p>
                    </td>
                    <td>
                      <p class="font-12 text-center">ใช้ไป</p>
                    </td>
                    <td>
                      <p class="font-12 text-center">คงเหลือ</p>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <p class="font-12 mt-5">แต้มสมาชิก</p>
                    </td>
                    <td>
                      <p class="font-12 text-center mt-5">
                        +{{
                          detailList.invoice.member_name == null
                            ? formatPrice(0)
                            : formatPrice(detailList.invoice.point)
                        }}
                      </p>
                    </td>
                    <td>
                      <p class="font-12 text-center mt-5">
                        {{ formatPrice(detailList.invoice.use_point) }}
                      </p>
                    </td>
                    <td>
                      <p class="font-12 text-center mt-5">
                        {{ formatPrice(detailList.invoice.point_remain) }}
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="4">
                      <div class="color-gray-mid font-10 mt-4">
                        ** ยอดใช้ไปและยอดคงเหลือ ไม่รวมยอดสะสมครั้งนี้ **
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <!--End Table-->

              <div id="legalcopy" class="text-center">
                <p class="font-14">ขอบคุณที่ใช้บริการ</p>
              </div>
            </div>
            <!--End InvoiceBot-->
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Swal from "sweetalert2";
import { HTTP } from "@/axios.js";
// import { HTTP_ARIN } from "@/axios_arin.js";
import { isTelephone, onPaste, validateEmail } from "@/js/handler";
import { formatPrice } from "@/js/handler";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "StoreInformation",
  data() {
    return {
      loading_page: false,
      loading_modal: false,
      add_partner: false,
      search: null,
      modal_details: false,
      modal_edit: false,
      modal_delete: false,
      alert_success: false,
      alert_reset: false,
      disabled_status: false,
      login_focus: false,
      show_detail_bill: false,
      show: false,
      emailRules: [
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "อีเมลไม่ถูกต้อง !",
      ],
      phoneRules: [(v) => v.length > 8 || "เบอร์โทรศัพท์ไม่ถูกต้อง !"],
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        "items-per-page-text": "รายการต่อหน้า",
      },

      partnerHeader: [],
      all_invoice: [],
      total_qty: null,
      print_receipt: false,
      vat_type: null,
      bill_status: null,
      detailList: [],
      total_price: null,
      user_cancel: null,
      seller: {},
      status_invoice_tax: null,
      status_invoice_refund: null,
      vowelCharacters: "aeiouAEIOUะัาำิีึื็ุู่้๊๋์ํๆ",
      date_start: null,
      date_end: null,
      menu_date_start: false,
      menu_date_end: false,
    };
  },
  methods: {
    isNumber: function (evt, number) {
      return isTelephone(evt, number);
    },
    isEmail: function (evt) {
      return validateEmail(evt);
    },
    isPaste: function (evt) {
      return onPaste(evt);
    },

    formatPrice(number) {
      return formatPrice(number);
    },

    async page() {
      this.partnerHeader = [
        {
          text: "เลขที่ใบเสร็จ",
          value: "invoice_code",
          fixed: true,
          width: "130px",
        },
        {
          text: "วัน-เวลา",
          value: "updated_at",
          fixed: true,
          width: "130px",
        },
        {
          text: "ยอดขาย",
          value: "total",
          fixed: true,
          width: "130px",
        },
        {
          text: "การชำระเงิน",
          value: "",
          fixed: true,
          width: "130px",
        },
        {
          text: "จัดการ",
          value: "",
          fixed: true,
          width: "120px",
        },
      ];
      this.getInvoice();
    },

    getPaymentType(item) {
      switch (Number(item)) {
        case 0:
          return "ยังไม่ได้จ่าย";
        case 1:
          return "เงินสด ";
        case 2:
          return "เงินโอน ";
        case 3:
          return "เครดิต ";
        case 4:
          return "อื่นๆ ";
        case 5:
          return "QR Code ";
      }
    },
    parsePayType(raw) {
      let result = [];
      try {
        if (typeof raw === "string") {
          result = JSON.parse(raw);
        } else if (Array.isArray(raw)) {
          result = raw;
        }
      } catch (e) {
        result = [];
      }

      return result
        .map((type) => {
          switch (Number(type)) {
            case 1:
              return "เงินสด";
            case 2:
              return "เงินโอน";
            case 3:
              return "เครดิต";
            case 4:
              return "อื่นๆ";
            case 5:
              return "QR Code";
            default:
              return "-";
          }
        })
        .join(", ");
    },

    exportExcel() {
      const payload = {
        date_start: this.date_start,
        date_end: this.date_end,
      };

      HTTP.post(
        `/customers/storeinvoicelist/${this.$route.params.id}`,
        payload
      ).then((res) => {
        if (res.data.success === true) {
          const data = res.data.object;

          const exportData = data.map((item) => {
            const payTypes = this.parsePayType(item.pay_type);

            return {
              วันที่: item.updated_at.split(" ")[0],
              เลขที่บิล: item.invoice_code,
              มูลค่าสินค้า: item.cost,
              มูลค่าส่วนลด: item.discount,
              มูลค่าหลังหักส่วนลด: item.cost,
              ยกเว้นภาษี: item.cost,
              ภาษีมูลค่าเพิ่ม: item.vat,
              ประเภทภาษี: "ภาษีรวมใน",
              อัตราภาษี: "7%",
              มูลค่าสุทธิ: item.total,
              ประเภทชำระเงิน: payTypes,
            };
          });

          const worksheet = XLSX.utils.json_to_sheet(exportData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "รายงาน");

          XLSX.writeFile(
            workbook,
            `รายงาน_${this.date_start}_ถึง_${this.date_end}.xlsx`
          );
        }
      });
    },
    exportExcelJson(data) {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "รายงาน");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const fileData = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(fileData, `report_${this.date_start}_ถึง_${this.date_end}.xlsx`);
    },

    checkLoading() {
      this.loading_page = true;
      HTTP.post(`/customers/storeinvoicelist/${this.$route.params.id}`).then(
        (res) => {
          if (res.data.success === true) {
            this.loading_page = false;
            this.all_invoice = res.data.object;
          }
        }
      );
    },

    getInvoice() {
      HTTP.post(`/customers/storeinvoicelist/${this.$route.params.id}`, {
        date_start: this.date_start,
        date_end: this.date_end,
      }).then((res) => {
        if (res.data.success === true) {
          this.all_invoice = res.data.object;
        }
      });
    },

    async getInvoiceDetail(invoice_code) {
      HTTP.get(
        `/customers/storeinvoiceById/${invoice_code}/${this.$route.params.id}`
      ).then((res) => {
        if (res.data.success === true) {
          this.detailList = res.data.data;

          this.detailList.invoice_list.forEach((detail) => {
            if (detail.product_code != null) {
              this.total_qty += parseFloat(detail.qty);
              this.total_price += parseFloat(detail.total);
            }
          });
          this.show_detail_bill = true;
        }
      });
    },

    close_model_all() {
      this.show_detail_bill = false;
    },

    // async getDetail(id) {
    //   this.total_qty = 0;
    //   this.total_price = 0;
    //   let config = {
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
    //     },
    //   };
    //   await HTTP_ARIN.get(`/pos/invoice/detail/${id}`, config).then((res) => {
    //     if (res.data.successful === true) {
    //       this.detailList = res.data.data;
    //       this.detailList.invoice_list.forEach((detail) => {
    //         if (detail.product_code != null) {
    //           this.total_qty += parseFloat(detail.qty);
    //           this.total_price += parseFloat(detail.total);
    //         }
    //       });
    //       this.getSotre();
    //       this.show_detail_bill = true;
    //     }
    //   });
    // },

    checkLogIn() {
      if (this.$store.state.access_token === null) {
        this.$store.commit("logout_success");
        this.$router.push("/login");
      } else if (
        this.$store.state.userDetail.manage_partner_list == 0 &&
        this.$store.state.userDetail.manage_partner_create == 0 &&
        this.$store.state.userDetail.manage_partner_edit == 0 &&
        this.$store.state.userDetail.manage_partner_delete == 0
      ) {
        this.$router.push("/retailer");
      }
    },
  },
  beforeMount() {
    this.checkLogIn();
    this.checkLoading();
  },
  mounted() {
    this.page();
  },
};
</script>

<style scoped>
.pos-main-bg {
  background-color: #957e5d !important;
  color: #fff;
}

.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_flex {
  display: flex;
}

@media only screen and (max-width: 500px) {
  .grid_flex {
    display: grid;
  }

  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .btn_mobile {
    width: 100%;
  }
}
</style>

<style scoped>
.btn_add_data {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  /* width: 100%; */
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px;
  min-width: 45px;
  padding: 0 10px;
}
.border-bill {
  border: 1px solid #f0f0f0;
}

.border-bill-red {
  border: 1px solid #ec6162;
}
.border-style-b {
  /* border-style: dotted;
    border-color: #ADADAD; */
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 1px dotted #adadad;
}
.title_page_right {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title_page_center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
#invoice-POS {
  box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
  padding: 2mm;
  margin: 0 auto;
  width: 80mm;
  background: #fff;
}
::selection {
  background: #f31544;
  color: #fff;
}
::moz-selection {
  background: #f31544;
  color: #fff;
}
h1 {
  font-size: 1.5em;
  color: #000000;
}
h2 {
  font-size: 1.2em;
}
h3 {
  font-size: 1.2em;
  font-weight: 300;
  line-height: 2em;
}
p {
  font-size: 1em;
  color: #000000;
  line-height: 1.2em;
}

#top,
#mid,
#bot {
  /* Targets all id with 'col-' */
  border-bottom: 1px solid #eee;
}

#top {
  min-height: 100px;
}
#mid {
  min-height: 80px;
}
#bot {
  min-height: 50px;
}

#top .logo {
  /*float: left;*/
  /* height: 60px; */
  width: 150px;
  /* background: url('img_arin') no-repeat; */
  background-size: 60px 60px;
}
.clientlogo {
  float: left;
  height: 60px;
  width: 60px;
  background: url(http://michaeltruong.ca/images/client.jpg) no-repeat;
  background-size: 60px 60px;
  border-radius: 50px;
}
.info {
  display: block;
  /*float:left;*/
  margin-left: 0;
}
.title {
  float: right;
}
.title p {
  text-align: right;
}
table {
  width: 100%;
  border-collapse: collapse;
}
td p {
  font-size: 0.9em;
  /*padding: 5px 0 5px 15px;*/
  /*border: 1px solid #EEE*/
}
.tabletitle {
  /*padding: 5px;*/
  font-size: 0.6em;
  /* background: #EEE; */
}
.service {
  border-bottom: 0px solid #eee;
}
.item {
  width: 40mm;
}
.item-med {
  width: 15mm;
}
.itemtext {
  font-size: 0.9em;
}
.Rate {
  font-size: 0.9em;
}
.payment {
  font-size: 1.2em;
}

#legalcopy {
  margin-top: 7mm;
  margin-bottom: 7mm;
}
.flex-center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.pr-5 {
  padding-right: 5px;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.w-100 {
  width: 100%;
}
.color-gray {
  color: #000000;
}
.color-gray-mid {
  color: #000000;
}
.va-top {
  vertical-align: top;
}
.mt-10 {
  margin-top: 10px;
}
.mt-5 {
  margin-top: 7px;
}
.mt-4 {
  margin-top: 4px;
}
.font-12 {
  font-size: 14px;
}
.font-13 {
  font-size: 15px;
}

.color-grey {
  color: #9d9d9d;
}

.circle {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  margin-right: 5px;
}

.blue {
  background-color: #5353d3 !important;
}

.cyan {
  background-color: #53cdd3 !important;
}

.orange {
  background-color: #ef8d1e !important;
}
</style>
